import React from "react";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

interface SectionHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle: string;
  completion?: string;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  icon,
  title,
  subtitle,
  completion,
}) => {
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: isXsOrSm ? "start" : "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mr: 1,
        }}
      >
        <Box
          sx={{
            display: { xs: "none", sm: "flex" },
          }}
        >
          {icon}
        </Box>
        <Box>
          <Typography
            component="h1"
            sx={{
              fontFamily: "Jost, sans-serif",
              fontWeight: 600,
              fontSize: "15px",
              lineHeight: "21px",
              letterSpacing: "0px",
              color: "#5d586c",
              mb: 0.5,
            }}
          >
            {title}
          </Typography>
          <Typography
            component="h2"
            sx={{
              fontFamily: "Jost, sans-serif",
              fontWeight: 500,
              fontSize: "11px",
              lineHeight: "20px",
              letterSpacing: "0px",
              color: "#a5a3ae",
              mt: 0,
            }}
          >
            {subtitle}
          </Typography>
        </Box>
      </Box>

      {completion && (
        <Typography
          variant="body1"
          sx={{
            display: { xs: "flex", sm: "block" },
            flexDirection: "column",
            alignItems: "flex-end",
            fontFamily: "Jost, sans-serif",
            fontWeight: 500,
            fontSize: "13px",
            lineHeight: "20px",
            letterSpacing: "0px",
            color: "#b7b5be",
            whiteSpace: "nowrap",
          }}
        >
          Fields Completion{" "}
          <Box
            component="span"
            sx={{
              fontFamily: "Jost, sans-serif",
              fontWeight: 500,
              fontSize: "15px",
              lineHeight: "22px",
              letterSpacing: "0px",
              color: "#00b3b5",
            }}
          >
            {completion}
          </Box>
        </Typography>
      )}
    </Box>
  );
};
